<template>
  <div>
    <div class="container">
      <p>
        <button
          class="btn btn-default btn-lg center-block instagram_button"
          type="button"
          v-on:click="clickLink()"
        >
          <img
            class="instagram_logo"
            :src="app_root + '/assets/common/img/logo/instagram_white_glyph-logo_May2016.png'"
          />
          <span>
            <LabelFunMessage fcontId="0" msgkey="156" />
          </span>
          <img v-if="isPc"
            class="instagram_qr"
            :src="app_root + '/assets/common/img/insta_epsongallery.png'"
          />
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "InstaGalleryButton",
  components: {
    LabelFunMessage,
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  computed: {
    ...mapState(["os"]),
    isPc: function () {
      return this.os == "ws" || this.os == "mi";
    },
    eventCategory: function() {
      let category = "fun"
      const result = this.$route.path.match(/\/\d+/)
      if (result!=null) {
        category = "fcont"
      }
      return category;
    },
    eventLabel: function () {
      let label = "top"
      const result = this.$route.path.match(/\/\d+/)
      if (result!=null) {
        label = "fcont_" + this.fcontId
      }
      return label;
    },
    articleNo: function () {
      let label = "other"
      const result = this.$route.path.match(/\/\d+/)
      if (result!=null) {
        label = this.fcontId
      }
      return label;
    },
    fcontId: function () {
      return this.$route.path.match(/\/\d+/).shift().slice(1)
    }
  },
  methods: {
    clickLink: function () {
      // GA4
      this.$gtag.event("go_sns", {
        "sns_name": "instagram",
        "location_id": "article",
        "article_no": this.articleNo
      })
      window.open("https://www.instagram.com/epsongallery/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.instagram_button {
  margin-top: 10px;
  width: 90%;
  max-width: 590px;
  white-space: normal;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background:rgb(207,46,146);
  box-shadow: 0px 1px 2px rgb(0 0 0 / 30%);
}

.instagram_logo {
  height: 48px; 
  margin: 14px 24px 14px 24px; 
}

.instagram_button span {
  margin-right: 24px;
}

.instagram_qr {
  height: 100px; 
  margin: 14px 24px 14px 0px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {

  .instagram_logo {
    width: 40px; 
    height: 40px; 
    margin: 10px 20px 10px 10px; 
  }
  
  .instagram_button span {
    font-size: 14px;
    margin-right: 0px;
  }
}
</style>